module.exports = __webpack_public_path__ + "static/media/YM90_2.1fca4d68.jpg";